 <template>
  <div>
    <el-form
      label-position="top"
      ref="form"
      :rules="rules"
      :hide-required-asterisk="true"
      label-width="80px"
      :model="formLabelAlign"
    >
      <div>請注意：編輯時，已完成作業的學生，則不需要再做。</div>
      <vue-dividing-line title="學生"></vue-dividing-line>
      <el-row type="flex" align="top" justify="space-between">
        <el-col :span="12">
          <vue-dividing-line title="學生庫"></vue-dividing-line>
          <div class="job-table-box">
            <el-form
                :model="ruleForm"
                :hide-required-asterisk="true"
                label-position="top"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
            >
              <el-row type="flex" align="middle" :gutter="10">
                <el-col :span="8">
                  <el-form-item label="老師標籤">
                    <el-autocomplete
                        popper-class="my-autocomplete"
                        v-model="ruleForm.tagsLike"
                        :fetch-suggestions="querySearch"
                        placeholder="請輸入老師標籤"
                        @select="handleSelect"
                        clearable
                    >
                      <i
                          class="el-icon-edit el-input__icon"
                          slot="suffix"
                          @click="handleIconClick">
                      </i>
                      <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                      label="學生帳號"

                  >
                    <el-input
                        v-model="ruleForm.userNoLike"
                        placeholder="請輸入學生帳號"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                      label="學生姓名"

                  >
                    <el-input
                        v-model="ruleForm.nameLike"
                        placeholder="請輸入學生姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                      label="分校學生編號"

                  >
                    <el-input
                        v-model="ruleForm.studentCodeLike"
                        placeholder="搜尋分校學生編號"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                      label="年級"

                  >
                    <el-select v-model="ruleForm.gradeId" placeholder="全部">
                      <el-option
                          v-for="(item, index) in grades"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" align="middle" style="margin-bottom:10px;">
                <el-col>
                  <el-button type="warning" @click="onSearch" size="mini"
                  >搜尋</el-button
                  >
                  <el-button size="mini"
                      @click="onReset"
                  >重置</el-button
                  >
                </el-col>
              </el-row>
            </el-form>
            <div class="users-table-box">
              <el-table
                  :data="users"
                  style="width: 100%;"
              >
                <el-table-column prop="userNo" label="學生帳號" sortable="custom"></el-table-column>
                <el-table-column prop="name" label="學生姓名" sortable="custom"> </el-table-column>
                <el-table-column
                    prop="studentCode"
                    label="分校學生編號"
                    align="center"
                    sortable="custom"
                >
                </el-table-column>
                <el-table-column prop="gradeId" label="年級" align="center" sortable="custom">
                  <template slot-scope="{ row }">
                    <span v-if="row.grade">{{ row.grade.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="tags" label="老師" sortable="custom"> </el-table-column>
                <el-table-column label="操作" sortable="custom">
                  <template slot-scope="{ row }">
                    <el-link type="warning" @click="addSingleStudent(row)">加入</el-link>
                  </template>

                </el-table-column>

              </el-table>
            </div>
          </div>
        </el-col>
<!--        <el-col :span="2" class="row-button-list" style="text-align: center;">-->
<!--          <el-button type="warning" @click="onArrowRight"-->
<!--          >加入<i class="el-icon-arrow-right"></i></el-button>-->
<!--          <el-button type="warning" @click="onArrowLeft"-->
<!--          >移除<i class="el-icon-arrow-left"></i></el-button>-->
<!--        </el-col>-->
        <el-col :span="11">

          <vue-dividing-line title="學生名單"></vue-dividing-line>
          <div class="job-table-box">
            <el-table
                :data="formLabelAlign.students"
                @selection-change="studentsSelectionChange"
                style="width: 100%;"
            >
              <el-table-column type="selection" width="50"> </el-table-column>
              <el-table-column prop="userNo" label="學生帳號">
              </el-table-column>
              <el-table-column prop="name" label="學生姓名"> </el-table-column>
              <el-table-column
                  prop="studentCode"
                  label="分校學生編號"
                  align="center">
              </el-table-column>
              <el-table-column prop="gradeName" label="年級">
                <template slot-scope="{ row }">
                  <span v-if="row.grade">{{ row.grade.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="tags" label="老師"> </el-table-column>
              <el-table-column prop="state" label="狀態">
                <template #default="scope">
                  {{ scope.row.state === 1 ? '已完成' : '未完成' }}
                </template>
              </el-table-column>
              <!-- 單行移除按鈕 -->
              <el-table-column label="操作" width="90">
                <template #default="scope">
                  <el-link size="mini" type="danger" @click="removeSingleStudent(scope.row)">移除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <vue-dividing-line title="題目"></vue-dividing-line>
      <el-form-item prop="passScore" style="display: none;">
        <div slot="label">
          <div class="label-text">
            及格分數線
            <span class="star-mark">*</span>
          </div>
        </div>
        <el-input v-model="formLabelAlign.passScore" @input="handleInput"></el-input>
      </el-form-item>
      <div>
        <div class="label-text">
          題目
          <span class="star-mark">*</span>
        </div>
      </div>
      <draggable
          v-model="formLabelAlign.homeworkScopes"
          animation="300"
          handle=".mover"
      >
        <el-row
            type="flex"
            align="middle"
            v-for="(item, index) in formLabelAlign.homeworkScopes"
            :key="index"
            :gutter="30"
        >
          <el-col :span="6">
            <el-form-item
                label="課題"
                :prop="'homeworkScopes.' + index + '.topicNumber'"
                :rules="[
                { required: true, message: '請選擇課題', trigger: 'blur' },
              ]"
            >
              <el-input
                  v-model="item.topicNumber"
                  disabled
                  placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="練習"
                :prop="'homeworkScopes.' + index + '.practiseNumber'"
                :rules="[
                { required: true, message: '請選擇練習', trigger: 'blur' },
              ]"
            >
              <el-select
                  value-key="practiseNumber"
                  @change="onChangePractiseNumber(index, item.practiseNumber)"
                  @focus="onFocusPractiseNumber(index, item)"
                  filterable
                  v-model="item.practiseNumber"
                  placeholder="請選擇練習"
              >
                <el-option
                    v-for="item in practises[index]"
                    :key="item.practiseNumber"
                    :label="item.practiseNumber"
                    :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                :label="'隨機抽取(最大不能超過'+(questionLengths[index] || item.maxRandomNumber || 0)+')'"
                :prop="'homeworkScopes.' + index + '.randomNumber'"
                :rules="[
                {
                  required: true,
                  message: '請輸入隨機抽取數量',
                  trigger: 'blur',
                },
                  {
                    validator: (rule, value, callback) => validateMaxNumber(rule, value, callback, index,item.maxRandomNumber),
                    trigger: 'blur'
                  },
              ]"
            >
              <el-input
                  v-model="item.randomNumber"
                  placeholder="請輸入隨機抽取數量"
                  :max="questionLengths[index] || item.maxRandomNumber"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="margin-top:33px;">
            <i class="el-icon-rank mover"></i>
          </el-col>
          <el-col :span="2" style="margin-top:33px;">
            <i class="el-icon-close" @click="onClose(index)"></i>
          </el-col>
        </el-row>
      </draggable>
      <el-button type="info" icon="icon iconfont icon-jiahao" @click="onAdd"  class="button-el-el plus-outline-add">添加更多題目</el-button>
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="6">
          <el-form-item label="" prop="number">
            <div class="label-text">
              作業編號
              <span class="star-mark"> * 不可重複</span>
            </div>
            <el-input v-model="formLabelAlign.number"></el-input> </el-form-item
        ></el-col>
        <el-col :span="6">
          <el-form-item label="" prop="name">
            <div class="label-text">
              作業名稱
              <span class="star-mark"> * 可重複</span>
            </div>
            <el-input v-model="formLabelAlign.name"></el-input> </el-form-item
          ></el-col>
        <el-col :span="6">
          <el-form-item label="" prop="lang">
            <div class="label-text">
              課程版本
              <span class="star-mark"> *</span>
            </div>
            <el-select v-model="formLabelAlign.lang" placeholder="請選擇課程版本">
              <el-option
                v-for="item in languages"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="6">
          <el-form-item label="" prop="gradeId">
            <div class="label-text">
              年級
              <span class="star-mark"> *</span>
            </div>
            <el-select
              v-model="formLabelAlign.gradeId"
              placeholder="請選擇年級"
            >
              <el-option
                v-for="(item, index) in grades"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="12">
          <el-form-item prop="startDate">
            <div slot="label">
              <div class="label-text">開始日期<span class="star-mark">*</span></div>
            </div>
            <el-date-picker
              v-model="formLabelAlign.startDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="請選擇開始日期"
              :picker-options="startPickerOptions"
              @change="handleStartTimeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <div slot="label">
              <div class="label-text">結束日期<span class="small-text">(結束時間可以不填寫)</span> </div>
            </div>
            <el-date-picker
              v-model="formLabelAlign.endDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="請選擇結束日期"
              :picker-options="endPickerOptions"
              @change="handleEndTimeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisibleQuestion">
          <topicItem :lang="formLabelAlign.lang" :gradeId="formLabelAlign.gradeId"  @select="selectTopicItem" @iconClose="iconCloseSelect"></topicItem>
    </dialogSlotVisible>
  </div>
</template>

<script>
import {getGrades} from '@/api/grade'
import topicItem from './topicItem'
import dialogSlotVisible from "@/components/dialogSlotVisible";
import {getTags, getUsers} from "@/api/users";
import { getTopicsDetail } from "@/api/topics";
import { getPractises } from "@/api/practises";
import draggable from "vuedraggable";
import {formatddMMyyyyHHmmss} from "@/filters";
export default {
  components: { draggable,topicItem,dialogSlotVisible },
  props: {
    formLabelAlign: {
      type: Object,
      default: () => ({       // ✅ 必须是箭头函数返回【对象】
        name: null,             // ✅ 必须给 name 初始空字符串
        number: '',
        homeworkScopes: [],
        students: [],
        passScore: '',
        startDate: '',
        endDate: '',
        lang: '',
        gradeId: null
      })
    }
  },
  created() {
    // this.getUsers();
    this.getGrades();
    this.getTags();
  },
  data() {
    return {
      questionLengths: [],
      centerDialogVisibleQuestion:false,
      ruleForm: {
        tagsLike: null,
        gradeId: null,
        nameLike: null,
        userNoLike: null,
        studentCodeLike: null,
        orderBy: null,
      },
      grades: [],
      users: [],
      topics: [],
      restaurants: [],
      allTag: "",
      practises: [],
      tableData: [],
      handleSelection: [],
      studentsSelection: [],
      startPickerOptions: {
        disabledDate: (time) => {
          if (this.formLabelAlign.endDate) {
            return time.getTime() > new Date(this.formLabelAlign.endDate).getTime();
          }
          return false;
        }
      },
      endPickerOptions: {
        disabledDate: (time) => {
          if (this.formLabelAlign.startDate) {
            return time.getTime() < new Date(this.formLabelAlign.startDate).getTime();
          }
          return false;
        }
      },
      rules: {
        number: [
          { required: true, message: "請輸入課程編號", trigger: "blur" },
        ],
        name: [
          { required: true, message: "請輸入課程名稱", trigger: "blur" },
        ],
        lang: [{ required: true, message: "請選擇課程版本", trigger: "change" }],
        gradeId: [{ required: true, message: "請選擇年級", trigger: "change" }],
        passScore: [
          { required: true, message: "請輸入通過分數", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 获取标签列表
    getTags() {
      getTags().then((v) => {
        this.allTag = v.data || '';
        const result = this.allTag.split(',')
            .map(item => item.trim())
            .filter(item => item)
            .filter((item, index, self) => self.indexOf(item) === index)
            .map(item => ({ value: item }));

        this.restaurants = result;
      }).catch(err => {
        console.error('获取标签失败：', err);
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    handleInput(value) {
      // 1. 过滤非数字和小数点
      let newValue = value.replace(/[^\d.]/g, '');
      
      // 2. 处理小数点情况
      newValue = newValue
        .replace(/^\./, '0.')        // 首位为小数点时补零
        .replace(/\.{2,}/g, '.')     // 禁止多个小数点
        .replace(/(\..*)\./g, '$1');// 保留第一个小数点
      
      // 3. 处理前导零（如 "00" → "0"，"0123" → "123"）
      if (newValue.startsWith('0') && newValue !== '0' && !newValue.includes('.')) {
        newValue = newValue.replace(/^0+/, '');
      }
      
      this.formLabelAlign.passScore = newValue;
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.ruleForm.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.ruleForm.orderBy = column.prop + " asc";
      } else {
        this.ruleForm.orderBy = null;
      }
      this.getUsers();
    },
    handleStartTimeChange(value) {
      this.formLabelAlign.startDate = value;
      if (this.formLabelAlign.endDate && new Date(this.formLabelAlign.startDate) > new Date(this.formLabelAlign.endDate)) {
        this.formLabelAlign.endDate = '';
      }
    },
    handleEndTimeChange(value) {
      this.formLabelAlign.endDate = value;
    },
    getGrades(){
      getGrades().then((res)=>{
         this.grades = res.data
      })
    },
    onFocusPractiseNumber(index,item){
      getTopicsDetail(item.topicId).then((v)=>{
         let numders = v.data.practises.map((f)=>{
             return f.number
         });
        let numdersR = [];
        if(v.data.smallTest.practises != null){
           numdersR = v.data.smallTest.practises.map((f)=>{
             return f.number
           })
        }

        // 使用 concat() 合并数组
        let combinedNumbers = numders.concat(numdersR);
         this.getPractises(index, combinedNumbers);
      })
    },
    selectTopicItem(value){
      this.formLabelAlign.homeworkScopes.push(value)
      this.onChangeTopic(this.formLabelAlign.homeworkScopes.length,value)
      this.centerDialogVisibleQuestion = false
      if(this.formLabelAlign.number!=null && this.formLabelAlign.number!=''){
        this.formLabelAlign.number=this.formLabelAlign.number+'_'+value.number
      }else{
        this.formLabelAlign.number=formatddMMyyyyHHmmss()+'_'+value.number
      }
    },
    iconCloseSelect(){
      this.centerDialogVisibleQuestion = false
    },
    onSearch(){
      this.getUsers()
    },
    onReset(){
      Object.keys(this.ruleForm).forEach((key) => {
        this.ruleForm[key] = null;
      })
      this.users = []
    },
    onArrowLeft() {
      this.tableData.push(...this.studentsSelection);
      this.formLabelAlign.students = this.deleteSpecificElement(
        this.formLabelAlign.students,
        this.studentsSelection
      );
    },
    onArrowRight() {
      this.formLabelAlign.students.push(...this.handleSelection);
      this.tableData = this.deleteSpecificElement(
        this.tableData,
        this.handleSelection
      );
    },
    // 單個學生加入右側名單
    addSingleStudent(row) {
      // 過濾已存在學生，避免重複新增
      const exist = this.formLabelAlign.students.some(item => item.id === row.id)
      if (exist) {
        this.$message.warning('該學生已在名單內')
        return
      }
      this.formLabelAlign.students.push(row)
      // 從左側學生庫移除當前行（可按需保留/註釋）
      this.users = this.users.filter(item => item.id !== row.id)
    },
    // 單個學生移除，放回左側庫
    removeSingleStudent(row) {
      // 過濾移除當前學生
      this.formLabelAlign.students = this.formLabelAlign.students.filter(item => item.id !== row.id)
      // 放回左側學生庫（避免重複先判斷）
      const has = this.users.some(u => u.id === row.id)
      if (!has) {
        this.users.push(row)
      }
    },
    handleSelectionChange(v) {
      this.handleSelection = v;
    },
    studentsSelectionChange(v) {
      this.studentsSelection = v;
    },
    onClose(index) {
      this.formLabelAlign.number=null;
      this.formLabelAlign.homeworkScopes.forEach((item, i) => {
        if(index !=i ){
          if(this.formLabelAlign.number!=null && this.formLabelAlign.number!=''){
            this.formLabelAlign.number=this.formLabelAlign.number+'_'+item.topicNumber
          }else{
            this.formLabelAlign.number=item.topicNumber
          }
        }
      });
      this.formLabelAlign.homeworkScopes.splice(index, 1);

    },
    onAdd() {
      this.centerDialogVisibleQuestion = true
    },
    deleteSpecificElement(array, arr) {
      let newArr = [];
      arr.forEach((element) => {
        const index = array.findIndex((item) => item.id === element.id);
        if (index > -1) {
          array.splice(index, 1);
        }
      });

      newArr = array;
      return newArr;
    },
    onChangeTopic(index, item) {
      this.getPractises(index, item.practises);
      this.$forceUpdate()
    },
    onChangePractiseNumber(index, item) {
      this.formLabelAlign.homeworkScopes[index].practiseNumber =
        item.practiseNumber;
      this.formLabelAlign.homeworkScopes[index].practiseId = item.practiseId;
      // 设置随机抽取数量为题目总数（或设置最大限制）
      // this.formLabelAlign.homeworkScopes[index].randomNumber = item.questionLength;
      // 初始化或更新 questionLengths 数组
      this.questionLengths[index] = item.questionLength;
      console.info(this.formLabelAlign.homeworkScopes);
    },
    validateMaxNumber(rule, value, callback, index,randomNumber) {
      const maxValue = this.questionLengths[index] || randomNumber || 0;

      if (value > maxValue) {
        callback(new Error(`隨機抽取數量不能超過 ${maxValue}`));
      } else {
        callback();
      }
    },
    getPractises(index, numbers) {
      let from = {
        numbersIn: numbers,
      };
      getPractises(from).then((v) => {
        this.practises[index] = v.data.map((k) => {
          k.practiseId = k.id;
          k.practiseNumber = k.number;
          return k;
        });

        this.$set(this.practises, index, this.practises[index]);
      
      });
    },
    getUsers() {
      let from = {
        tags:this.ruleForm.tagsLike,
        userNoLike:this.ruleForm.userNoLike,
        nameLike:this.ruleForm.nameLike,
        studentCodeLike:this.ruleForm.studentCodeLike,
        gradeId:this.ruleForm.gradeId,
        orderBy: this.ruleForm.orderBy,
        type: 2,
      };
      getUsers(from).then((v) => {
        this.users = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.small-text{
  color: #97989b;
}
.job-table-box {
  padding: 10px 10px;
  background-color: #f2f2f2;
}
.row-button-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-items: center;
  .el-button {
    margin-left: 10px;
    margin-bottom: 10px;
  }
}
.plus-outline-add{
  margin: 20px 0;
}
::v-deep {
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
}
</style>